import React from 'react'

const RAF_TERMS_LINK =
  'https://cdn.smarty.co.uk/files/SMARTY-Refer-a-Friend.pdf'

export const content = {
  title: 'Pick a pal. Pick up DOUBLE rewards.',
  subTitle: 'Refer friends, get rewards.',
  description:
    'You both get up to £40 in rewards. PayPal, Amazon.co.uk, John Lewis & Partners, or Uber are yours to choose from. And you can refer as many friends as you like.',
  infoText: (
    <>
      By using this link, you agree for us to share your details with our
      partner, Buyapowa, to fulfil your reward. See{' '}
      <a
        href={RAF_TERMS_LINK}
        target="_blank"
        rel="noreferrer"
        data-testid="terms-link"
      >
        terms
      </a>{' '}
      for more details.
    </>
  ),
  copyCta: 'Copy your link',
  referCta: 'Refer Now',
}
